import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getEbayTasks = createAsyncThunk('ebay/getEbayTasks',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/ebay/tasks',
        {
          params
        });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getEbayTasks;
